import * as React from 'react';
import { forwardRef } from 'react';

import {
  Props,
} from 'one-ui';

export interface BoxProps extends Props {
}

type Ref = any;

export const Box = forwardRef<Ref, BoxProps>(({
  children,
}: BoxProps, ref) => (
  <div className="box" ref={ref}>
    {children}
  </div>
));
